import  { instance  } from "../api";


const fetchClientByUser = (setClientAttributes, setSelectedClient ) => {
   
      instance.get("/api/clients/utilisateur")
      .then((result)=>  { 
      setClientAttributes(result.data)

    //   setSelectedClient(result.data[0].id_client_gexpertise)
    const storedClient = JSON.parse(localStorage.getItem('selectedClient'));
      if (!storedClient) {
        setSelectedClient(result.data[0].id_client_gexpertise);
        localStorage.setItem('selectedClient', JSON.stringify(result.data[0].id_client_gexpertise));
      }
      else setSelectedClient(storedClient)
     })    
              
    .catch ((error) =>{console.log('error', error)
      
    })
};

export default fetchClientByUser;